import {
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material"
import ListItemText from "@mui/material/ListItemText"
import { useSelector } from "react-redux"
import { getConf } from "../../store/features/confSlice"
import FaceIcon from "@mui/icons-material/Face"
import axios from "axios"
import { useEffect, useState } from "react"
import CrisisAlertOutlinedIcon from "@mui/icons-material/CrisisAlertOutlined"
import { getAuth } from "../../store/features/authSlice"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const scopeMenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
}

export const ScopeLimitedToInput = ({
  scope,
  scopeLimitedTo,
  handleChangeElement,
}) => {
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [users, setUsers] = useState([])

  useEffect(() => {
    getUsers()
  }, [scope])

  const getUsers = async () => {
    try {
      console.log("searching...")
      const endpoint = `/user?role=2&person-type=1&state=1&limit=99999`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: {
          Authorization: auth.data.jwtToken,
        },
      })
      setUsers(data)
    } catch (e) {
      alert(e.message)
    }
  }

  const renderValueUser = (value, getTagProps) =>
    value.map((option, index) => (
      <Chip
        key={index}
        variant="outlined"
        icon={<FaceIcon />}
        label={option}
        {...getTagProps({ index })}
      />
    ))

  const renderValueChapter = (sel) => (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.5,
      }}
    >
      {conf.data.chapters
        .filter((ch) => sel.some((e) => e === ch.id))
        .map((item) => (
          <Chip
            key={item.id}
            variant="outlined"
            icon={<CrisisAlertOutlinedIcon />}
            label={item.name}
          />
        ))}
    </Box>
  )

  return (
    <Grid item xs={12}>
      {[2, 3].some((item) => item === scope) ? (
        <Autocomplete
          multiple
          value={scopeLimitedTo.length === 0 ? [] : scopeLimitedTo.split(";")}
          onChange={(event, newValue) => {
            handleChangeElement({
              target: {
                name: "scopeLimitedTo",
                value: Object.values(newValue).map((item) =>
                  typeof item === "object" ? item.id : item
                ),
              },
            })
          }}
          options={users}
          getOptionLabel={(option) =>
            option.id + ": " + option.name + " " + option.surname
          }
          filterSelectedOptions
          isOptionEqualToValue={(option, value) => option.id === value}
          renderInput={(params) => <TextField {...params} label="Segmentos" />}
          renderTags={renderValueUser}
        />
      ) : (
        <FormControl fullWidth>
          <InputLabel>Segmentos</InputLabel>
          <Select
            multiple
            name="scopeLimitedTo"
            value={scopeLimitedTo.length === 0 ? [] : scopeLimitedTo.split(";")}
            onChange={handleChangeElement}
            input={<OutlinedInput label="Segmentos" />}
            renderValue={renderValueChapter}
            MenuProps={scopeMenuProps}
          >
            {conf.data.chapters.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                <Checkbox
                  checked={scopeLimitedTo.split(";").indexOf(item.id) > -1}
                />
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Grid>
  )
}
